import packageJson from '../package.json';

export const config = {
  // NOTE:
  // Since during the build process we don't include our local .env file, all the env variables
  // will be "{}.VITE_XXX", we then use a script in our deployment to replace those variables
  // at runtime with environment variables in kubernetes

  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || '{}.VITE_ENVIRONMENT',
  GA_TRACKING_ID: import.meta.env.VITE_GA_TRACKING_ID || '{}.VITE_GA_TRACKING_ID',
  ASSETS_REPO: import.meta.env.VITE_ASSETS_REPO || '{}.VITE_ASSETS_REPO',

  OAUTH2_CLIENT_AUTH_CLIENT_ID:
    import.meta.env.VITE_OAUTH2_CLIENT_AUTH_CLIENT_ID || '{}.VITE_OAUTH2_CLIENT_AUTH_CLIENT_ID',
  OAUTH2_CLIENT_AUTH_REDIRECT_URI:
    import.meta.env.VITE_OAUTH2_CLIENT_AUTH_REDIRECT_URI ||
    '{}.VITE_OAUTH2_CLIENT_AUTH_REDIRECT_URI',
  OAUTH2_CLIENT_AUTH_SCOPE:
    import.meta.env.VITE_OAUTH2_CLIENT_AUTH_SCOPE || '{}.VITE_OAUTH2_CLIENT_AUTH_SCOPE',
  OAUTH2_CLIENT_AUTH_ENDPOINT:
    import.meta.env.VITE_OAUTH2_CLIENT_AUTH_ENDPOINT || '{}.VITE_OAUTH2_CLIENT_AUTH_ENDPOINT',
  OAUTH2_CLIENT_LOGOUT_ENDPOINT:
    import.meta.env.VITE_OAUTH2_CLIENT_LOGOUT_ENDPOINT || '{}.VITE_OAUTH2_CLIENT_LOGOUT_ENDPOINT',
  OAUTH2_CLIENT_AUTH_POST_LOGOUT_REDIRECT_URI:
    import.meta.env.VITE_OAUTH2_CLIENT_AUTH_POST_LOGOUT_REDIRECT_URI ||
    '{}.VITE_OAUTH2_CLIENT_AUTH_POST_LOGOUT_REDIRECT_URI',
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL || '{}.VITE_BACKEND_URL',

  KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL || '{}.VITE_KEYCLOAK_URL',
  KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM || '{}.VITE_KEYCLOAK_REALM',
  KEYCLOAK_CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || '{}.VITE_KEYCLOAK_CLIENT_ID',

  SSO_COOKIE_DOMAIN: import.meta.env.VITE_SSO_COOKIE_DOMAIN ?? '{}.VITE_SSO_COOKIE_DOMAIN',
  MASTERCLASS_URL: import.meta.env.VITE_MASTERCLASS_URL || '{}.VITE_MASTERCLASS_URL',

  CYPRESS_SCREENSHOT:
    (import.meta.env.VITE_CYPRESS_SCREENSHOT || '{}.VITE_CYPRESS_SCREENSHOT') === 'true',
  DISABLE_ANIMATIONS:
    (import.meta.env.VITE_DISABLE_ANIMATIONS || '{}.VITE_DISABLE_ANIMATIONS') === 'true',
  SIMULATION: (import.meta.env.VITE_SIMULATION || '{}.VITE_SIMULATION') === 'true',

  VERSION: packageJson.version,
};
